import VendPackage from './VendPackage'
import BaseLineItemEntity from '../baseclasses/BaseLineItemEntity'
import * as _ from "lodash";
export class VendPackageLineItem extends BaseLineItemEntity{
    ID?: number;
    VendPackageID?: number;
    VendPackage?: VendPackage;
    VendPrice?: number;
    CommissionPercent?: number;

    constructor() {
        super();
        this.VendPackage = new VendPackage();
    }
    CloneShallow(): VendPackageLineItem{
        var newItem:VendPackageLineItem = _.clone(this);
        newItem.VendPackage = null;
        return newItem;
    }
}

export default VendPackageLineItem;